/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Ai_Link_TextInputs */

const en_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get quick answers about Brave Leo`)
};

const id_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawaban cepat tentang Brave Leo`)
};

const ms_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawapan pantas tentang Brave Leo`)
};

const ca_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtingues respostes ràpides sobre Brave Leo`)
};

const cs_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získejte rychlé odpovědi o Brave Leo`)
};

const da_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få hurtige svar om Brave Leo`)
};

const de_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalten Sie schnelle Antworten zu Brave Leo.`)
};

const et_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saa kiireid vastuseid Brave Leo kohta`)
};

const es_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén respuestas rápidas acerca de Brave Leo`)
};

const fr_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir de l’aide concernant Brave Leo`)
};

const hr_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobite brze odgovore o usluzi Brave Leo`)
};

const it_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi risposte rapide su Brave Leo`)
};

const lv_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saņemiet ātras atbildes par Brave Leo`)
};

const lt_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaukite greitus atsakymus apie „Brave Leo“`)
};

const hu_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyors válaszok a Brave Leóról`)
};

const nl_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg meer informatie over Brave Leo`)
};

const nb_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få kjappe svar om Brave Leo`)
};

const pl_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzyskaj szybkie odpowiedzi na temat Brave Leo`)
};

const pt_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha respostas rápidas sobre o Brave Leo`)
};

const ro_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obține răspunsuri rapide despre Brave Leo`)
};

const sk_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získajte rýchle odpovede o Brave Leo`)
};

const sl_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pridobite hitre odgovore o storitvi Brave Leo`)
};

const fi_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanki nopeasti vastauksia Brave Leosta`)
};

const sv_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få snabba svar om Brave Leo`)
};

const vi_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham khảo câu trả lời nhanh về Brave Leo`)
};

const tr_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Leo hakkında hızlı yanıtlar alın`)
};

const el_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λάβετε γρήγορες απαντήσεις για το Brave Leo`)
};

const bg_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получи бързи отговори за Brave Leo`)
};

const ru_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите быстрые ответы о Brave Leo`)
};

const sr_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кратки одговори на питања о асистенту Brave Leo`)
};

const uk_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримайте швидкі відповіді про Brave Leo`)
};

const ka_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მიიღეთ სწრაფი პასუხები Brave Leo-ს შესახებ`)
};

const hi_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव लियो के बारे में जानकारी पाएं`)
};

const th_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับคำตอบอย่างรวดเร็วเกี่ยวกับ Brave Leo`)
};

const ko_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 레오에 관한 자주 묻는 질문`)
};

const zh_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取有关 Brave Leo 的快速解答`)
};

const zh_tw_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲取關於 Brave Leo 的快速解答`)
};

const ja_leo_ai_link_text = /** @type {(inputs: Leo_Ai_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Leoに関するクイックアンサー`)
};

/**
* | output |
* | --- |
* | "Get quick answers about Brave Leo" |
*
* @param {Leo_Ai_Link_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_ai_link_text = /** @type {((inputs?: Leo_Ai_Link_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Ai_Link_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_ai_link_text(inputs)
	if (locale === "ms") return ms_leo_ai_link_text(inputs)
	if (locale === "ca") return ca_leo_ai_link_text(inputs)
	if (locale === "cs") return cs_leo_ai_link_text(inputs)
	if (locale === "da") return da_leo_ai_link_text(inputs)
	if (locale === "de") return de_leo_ai_link_text(inputs)
	if (locale === "et") return et_leo_ai_link_text(inputs)
	if (locale === "es") return es_leo_ai_link_text(inputs)
	if (locale === "fr") return fr_leo_ai_link_text(inputs)
	if (locale === "hr") return hr_leo_ai_link_text(inputs)
	if (locale === "it") return it_leo_ai_link_text(inputs)
	if (locale === "lv") return lv_leo_ai_link_text(inputs)
	if (locale === "lt") return lt_leo_ai_link_text(inputs)
	if (locale === "hu") return hu_leo_ai_link_text(inputs)
	if (locale === "nl") return nl_leo_ai_link_text(inputs)
	if (locale === "nb") return nb_leo_ai_link_text(inputs)
	if (locale === "pl") return pl_leo_ai_link_text(inputs)
	if (locale === "pt") return pt_leo_ai_link_text(inputs)
	if (locale === "ro") return ro_leo_ai_link_text(inputs)
	if (locale === "sk") return sk_leo_ai_link_text(inputs)
	if (locale === "sl") return sl_leo_ai_link_text(inputs)
	if (locale === "fi") return fi_leo_ai_link_text(inputs)
	if (locale === "sv") return sv_leo_ai_link_text(inputs)
	if (locale === "vi") return vi_leo_ai_link_text(inputs)
	if (locale === "tr") return tr_leo_ai_link_text(inputs)
	if (locale === "el") return el_leo_ai_link_text(inputs)
	if (locale === "bg") return bg_leo_ai_link_text(inputs)
	if (locale === "ru") return ru_leo_ai_link_text(inputs)
	if (locale === "sr") return sr_leo_ai_link_text(inputs)
	if (locale === "uk") return uk_leo_ai_link_text(inputs)
	if (locale === "ka") return ka_leo_ai_link_text(inputs)
	if (locale === "hi") return hi_leo_ai_link_text(inputs)
	if (locale === "th") return th_leo_ai_link_text(inputs)
	if (locale === "ko") return ko_leo_ai_link_text(inputs)
	if (locale === "zh") return zh_leo_ai_link_text(inputs)
	if (locale === "zh-tw") return zh_tw_leo_ai_link_text(inputs)
	if (locale === "ja") return ja_leo_ai_link_text(inputs)
	return en_leo_ai_link_text(inputs)
});